export default __webpack_public_path__ + "static/media/coinlogo.bb0c9f04.svg";